import { FaFacebookF } from "react-icons/fa";
import "./VerticalMenu.css"; 
import {fanpage} from "../../data/aboutData.js"

function VerticalMenu({ activePage, setActivePage }) {
  const links = [
    "Św. Urszula", 
    "O Parafii", 
    "Duszpasterze", 
    "Grupy parafialne", 
    "Aktualności", 
    "Ogłoszenia",
    "Intencje",
    "Msze Święte", 
    "Nabożeństwa", 
    "Kancelaria", 
    "Ochrona dzieci",
    "Kontakt"
  ];

  return (
    <div className="verticalMenu">
      {links.map((link) => (
        <div
          key={link}
          className={`menuItem ${activePage === link ? "active" : ""}`}
          onClick={() => setActivePage(link)}
        >
          {link}
        </div>
      ))}

      <a
        href={fanpage}
        target="_blank"
        rel="noopener noreferrer"
        className="facebookLink"
      >
        <FaFacebookF className="facebookIcon" />
      </a>
    </div>
  );
}

export default VerticalMenu;
